exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card[data-v-68320668]{background:#f5f5f5;height:200px;width:370px;border-radius:16px;color:#000;position:relative}.img[data-v-68320668]{width:40%;margin-left:55%;position:absolute;bottom:20px;right:20px}", ""]);

// exports
